module.exports = __webpack_public_path__ + "img/R8804-IB.c93b2644.jpg";